import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const DeliveryOptions = ({ onEmailSend, onCloudSave }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleEmailSend = async () => {
    if (!emailAddress || !emailAddress?.includes('@')) return;
    
    setIsEmailSending(true);
    try {
      await onEmailSend(emailAddress);
      setEmailSent(true);
      setTimeout(() => setEmailSent(false), 3000);
    } catch (error) {
      console.error('Email send failed:', error);
    } finally {
      setIsEmailSending(false);
    }
  };

  const cloudOptions = [
    {
      name: 'Google Drive',
      icon: 'Cloud',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      action: () => onCloudSave('google-drive')
    },
    {
      name: 'Dropbox',
      icon: 'CloudUpload',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
      action: () => onCloudSave('dropbox')
    },
    {
      name: 'OneDrive',
      icon: 'Cloud',
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      action: () => onCloudSave('onedrive')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="Send" size={20} className="text-accent" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-semibold text-foreground">
            Delivery Options
          </h2>
          <p className="font-body text-sm text-muted-foreground">
            Send or save your planner
          </p>
        </div>
      </div>
      {/* Email Delivery */}
      <div className="mb-6">
        <h3 className="font-body font-medium text-foreground mb-3">
          Email to Yourself
        </h3>
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1">
            <Input
              type="email"
              placeholder="Enter your email address"
              value={emailAddress}
              onChange={(e) => setEmailAddress(e?.target?.value)}
              className="w-full"
            />
          </div>
          <Button
            variant="outline"
            onClick={handleEmailSend}
            disabled={!emailAddress || isEmailSending || emailSent}
            loading={isEmailSending}
            iconName={emailSent ? "Check" : "Mail"}
            iconPosition="left"
            className="sm:w-auto"
          >
            {emailSent ? 'Sent!' : 'Send Email'}
          </Button>
        </div>
        {emailSent && (
          <div className="mt-2 flex items-center space-x-2 text-success text-sm">
            <Icon name="CheckCircle" size={14} />
            <span>Email sent successfully!</span>
          </div>
        )}
      </div>
      {/* Cloud Storage */}
      <div>
        <h3 className="font-body font-medium text-foreground mb-3">
          Save to Cloud Storage
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {cloudOptions?.map((option) => (
            <button
              key={option?.name}
              onClick={option?.action}
              className={`
                p-4 rounded-lg border border-border hover:border-primary/20 
                transition-all duration-200 hover:scale-[1.02] group
                ${option?.bgColor} hover:bg-primary/5
              `}
            >
              <div className="flex flex-col items-center space-y-2">
                <div className={`w-8 h-8 ${option?.color} group-hover:text-primary transition-colors`}>
                  <Icon name={option?.icon} size={24} />
                </div>
                <span className="font-body text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                  {option?.name}
                </span>
              </div>
            </button>
          ))}
        </div>
        <p className="font-caption text-xs text-muted-foreground mt-3 text-center">
          Connect your account to save directly to cloud storage
        </p>
      </div>
    </div>
  );
};

export default DeliveryOptions;